var _path, _path2, _path3, _path4, _polygon, _rect, _rect2, _path5, _path6, _polygon2, _polygon3, _rect3, _polygon4, _polygon5, _path7, _rect4, _rect5, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElevator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M19.7,5.1H8.5v4.5H5.1v30.3h34.8V9.6H25.3V5.1H19.7z M15.2,6.2h3.4v3.4h-3.4V6.2z M9.6,6.2h4.5v3.4H9.6V6.2z  M8.5,38.8V13h7.8v25.8H8.5z M25.3,38.8h-7.8V13h7.8L25.3,38.8z M26.4,38.8v-27H7.3v27H6.2V10.7h21.4v28.1H26.4z M38.8,38.8H28.7 V10.7h10.1L38.8,38.8z M24.2,9.6h-4.5V6.2h4.5V9.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.7,6.2v3.4h4.5V6.2H19.7z M22.7,9.1l-0.8-0.8l-0.7,0.8l-0.8-0.8l1.5-1.5l1.6,1.5L22.7,9.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.6,9.6V6.2h-3.4v3.4H18.6z M16.3,8.5V7.3h1.2v1.2H16.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.1,9.6V6.2H9.6v3.4H14.1z M11.1,6.9l0.7,0.8l0.8-0.8l0.8,0.8l-1.6,1.6l-1.5-1.6L11.1,6.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "27.6,10.7 25.3,10.7 19.7,10.7 14.1,10.7 8.5,10.7 6.2,10.7 6.2,38.8 7.3,38.8 7.3,11.8 26.4,11.8  26.4,38.8 27.6,38.8 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 13,
    fill: "#FFFFFF",
    width: 7.9,
    height: 25.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 13,
    fill: "#FFFFFF",
    width: 7.9,
    height: 25.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.7,10.7v28.1h10.1V10.7H28.7z M33.7,35.8l-2.8-3.7h5.7L33.7,35.8z M36.6,30.9h-5.7V18.6h5.7V30.9z  M36.6,17.5h-5.7l2.8-3.8L36.6,17.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35.4,19.7h-3.3v4.5h1.1v1.1h-1.1v4.5h3.3v-4.5h-1.1v-1.1h1.1V19.7z M34.3,28.1h-1.1V27h1.1V28.1z  M34.3,22.5h-1.1v-1.1h1.1V22.5z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "33.2,16.3 34.3,16.3 33.7,15.6 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "33.7,33.9 34.3,33.2 33.2,33.2 "
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3,
    y: 7.3,
    fill: "#505050",
    width: 1.1,
    height: 1.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#28B557",
    points: "21.9,6.8 20.4,8.3 21.2,9.1 21.9,8.3 22.7,9.1 23.5,8.3 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#4AB8DC",
    points: "11.8,9.3 13.4,7.7 12.6,6.9 11.8,7.7 11.1,6.9 10.3,7.7 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.9,18.6v12.3h5.7V18.6H30.9z M35.4,24.2h-1.1v1.1h1.1v4.5h-3.3v-4.5h1.1v-1.1h-1.1v-4.5h3.3V24.2z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2,
    y: 21.4,
    fill: "#505050",
    width: 1.1,
    height: 1.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2,
    y: 27,
    fill: "#505050",
    width: 1.1,
    height: 1.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M30.9,17.5h5.7l-2.9-3.8L30.9,17.5z M33.2,16.3l0.5-0.7l0.6,0.7H33.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M30.9,32.1l2.8,3.7l2.9-3.7H30.9z M33.7,33.9l-0.5-0.7h1.1L33.7,33.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevator);
export default __webpack_public_path__ + "static/media/elevator.f16c770d315893e532c60aee805a85f5.svg";
export { ForwardRef as ReactComponent };